<template>
  <div class="general-wrapper">
    <Header>
      <template #actions>
        <BaseButton class="mr-8 nowrap" 
          variant="secondary"
          icon="refresh-cw"
          size="md"
          v-if="view == 'list' && currentPosSystem"
          @click="$router.push('/pos_integrations/'+currentPosSystem)">
          {{ $t("halls_tables.pos_sync") }}
        </BaseButton>
        <BaseButton
          @click="addHall"
          class="mr-8 nowrap"
          variant="secondary"
          icon="plus"
          color="v1-grey-10"
          size="md"
          v-if="view == 'list'"
        >
          {{ $t("halls_tables.add_hall") }}
        </BaseButton>
        <!-- <img
          :src="`/icons/tables-view-${view}.svg`"
          @click="toggleView"
          class="view-toggle"
        /> -->
        <BaseSelect v-model.number="selected_grid_section" fullWidth class="halls-select w-100 mr-8" v-if="view == 'grid'">
          <option
            v-for="(section, index) in cafe.sections"
            :key="index"
            :value="index"
          >
            {{ section.name || "№" + (index + 1) }}
          </option>
        </BaseSelect>
        <BaseTabSwitcher
          v-model="view"
          :tabs="[
            {
              value: 'list',
              icon: 'list',
            },
            {
              value: 'grid',
              icon: 'grid-bold',
            },
          ]"
        />
      </template>
    </Header>

    <PageContainer v-if="cafe && cafe.sections">
      <div v-if="view == 'list'">
        <SectionEditor
          v-for="(section, index) in cafe.sections"
          :key="index"
          :index="index"
          class="mb-24"
        />
      </div>
    </PageContainer>

    <HallsAndTablesGrid :selected_section="selected_grid_section" :edit="true" v-if="view == 'grid'" />
  </div>
</template>

<script>
import HallsAndTables from "@/components/halls/HallsAndTables.vue";
import SectionEditor from "@/components/halls/SectionEditor.vue";
import ModeSwitcher from "@/components/halls/ModeSwitcher.vue";

import HallsAndTablesGrid from "@/components/stats/HallsAndTablesGrid.vue";

export default {
  data() {
    return {
      view: "list",
      selected_grid_section: 0
    };
  },
  methods: {
    toggleView() {
      this.view = this.view == "list" ? "grid" : "list";
    },
    addHall() {
      this.cafe.sections.push({
        name: null,
        tables_list: [],
      });
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    currentPosSystem() {
      return this.$store.getters.currentPosSystem;
    }
  },
  components: {
    ModeSwitcher,
    HallsAndTables,
    HallsAndTablesGrid,
    SectionEditor,
  },
};
</script>

<style scoped>
.full-wide {
  width: 100%;
}

.view-toggle {
  cursor: pointer;
}

.halls-select {
  border: 1px solid var(--v1-grey-10-color);
  padding: 7px;
}
</style>
